import template from './manage-avatar.html';
import controller from './manage-avatar.controller';

let ManageAvatarModal = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: '$ctrl',
  size: 'lg',
  windowClass: 'hmodal-info animated fadeIn'
};

export default ManageAvatarModal;




// WEBPACK FOOTER //
// ./client/pages/profile/modals/manage-avatar/manage-avatar.component.js